import { Controller } from "@hotwired/stimulus"

// Gracefully handles Active Storage representation URLs that fail to load.
//
// This can happen when:
//   - A PDF is password-protected and poppler cannot generate a preview.
//   - A file misreports its content type (e.g. a plain-text file with a .jpg
//     extension that passes the variable? check but cannot be decoded by vips).
//
// When the <img> fires an error event, the controller replaces it with the
// same extension badge used by the server-side "else" branch in the file drop
// zone partials, keeping the UI consistent regardless of how the failure is
// detected.
//
// Usage — place directly on the <img> element:
//
//   <%= image_tag attachment.variant(...),
//         data: {
//           controller: "image-fallback",
//           image_fallback_ext_value: attachment.blob.filename.extension,
//           action: "error->image-fallback#fallback"
//         } %>

export default class extends Controller {
  static values = { ext: String }

  fallback() {
    const badge = document.createElement("span")
    badge.className = "text-xs font-bold text-slate-400 uppercase tracking-widest"
    badge.textContent = this.extValue || "file"
    this.element.replaceWith(badge)
  }
}
